/* eslint-disable no-nested-ternary */
/* eslint-disable no-undef */
import {
  useEffect, useState, useRef
} from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Countdown, { zeroPad } from 'react-countdown';
import { useHistory } from 'react-router-dom';
import Deck from './Deck';
import Levels from './Levels';
import GameStatusIndicator from './GameStatusIndicator';
import RoundResult from './RoundResult';
import TimeOutModal from './TimeOutModal';
import * as actions from '../../../redux/actions/recycleRight';
import SecondsCounter from './SecondsCounter';
import StaticGameScreen from './StaticGameScreen';
import Feedbacks from './Feedbacks';
import images from '../../../images';
import { trackEvent, turnMsToSeconds } from '../../../helpers/common';
import events from '../../../app/events';
import { iframeCall } from '../../../helpers/iframeHelper';
import TeachSwipingModal from './TeachSwipingModal';
import clockIcon from '../../../images/Clock.png';

const Container = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: calc(100vh - 40px - ${Number(window.statusBarHeight || 0)}px);
  margin-top: ${Number(window.statusBarHeight || 0)}px;
`;

const CountDownContainer = styled.div`
  position: fixed;
  display: flex;
  top: 0%;
  right: 6%;
  flex-direction: row;
`;

const TimerImage = styled.img`
  height: ${window.innerWidth / 15}px;
  width: ${window.innerWidth / 15}px;
  margin-top: 30%;
  margin-left: 5%;
  scale: 0.7;
`;

const TopContainer = styled.div`
  position: fixed;
  display: flex;
  top: 3%;
  justify-content: space-between;
  flex-direction: row;
`;

const CloseButton = styled.img`
  height: ${window.innerWidth / 20}px;
  width: ${window.innerWidth / 20}px;
  border-radius: 50%;
  position: fixed;
  top: 2.8%;
  left: 6%;
`;

const ButtonsContainer = styled.div`
  display: flex;
  position: fixed;
  bottom: 1%;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  transform: translate(50%, -100%);
`;

const ButtonImage = styled.img`
  height: 7vh;
  width: 7vh;
  border-radius: 50%;
  background-color: #efefef;
  background-size: contain;
  background-position: center;
  display: block;
  margin: 0 auto;
  border: 1px solid black;
`;

let timer;
const FEEDBACK_MESSAGE_DURATION = 1000;
let answeredElapsedTime;

// Renderer callback with condition
const renderer = ({ seconds }) => {
  answeredElapsedTime = seconds;
  return (
    <SecondsCounter seconds={zeroPad(seconds)} isBeforeGame={false} />
  );
};

/**
 * Display Recycle RIGHT game.
 * This component includes all the main functions and compnents of the game.
 * The main component of the game are as follows:
 *
 * StaticGameScreen component: shows the static page of the game, it will display as backgournd of
 * On Boarding or Timeout modals
 *
 * TimeoutModal component: shows a timout modal if user didn't answer a question in 5 seconds
 *
 * CountDownContainer component: shows the 5 seconds count down timer of game on top of game's page
 *
 * Levels component; shows the levels which passed or have not passed yet on the top of games' page
 *
 * RoundResult component: if user answers all questions of a level then will naviagte to
 * this page which includes the wrong and correct answers with their corespoding details
 *
 * Feedbacks component: if user answers a question then will naviagte to this page which
 * shows the result of the answer with Well Done or Oops for 1 second
 *
 * Deck component: shows cards of a level as a deck which user can press each of two buttons on it
 * or swipe the card to right or left to answer each question
 *
 * GameStatusIndicator component: shows correct and wrong answers of user in the current level
 * until the question that has been answered. The component is located on the bottom of games' page
 *
 * @author: Ashkan
 * @param {object} currentLevel Get game's current level from redux files
 * @param {object} doneMaterials Get game's done materials from redux files
 * @param {object} setDoneMaterial Add new materials to the game's done materials by redux files
 * @param {object} removeDoneMaterial Remove materials from the game's done materials by redux files
 * @param {object} setSwiperCurrentLevel Set game's current level by redux files
 * @param {object} recycleRightData Recycle RIGHT game's data
 */

const Game = ({
  currentLevel,
  doneMaterials,
  setDoneMaterial,
  removeDoneMaterial,
  setSwiperCurrentLevel,
  recycleRightData,
  rrGameOnly
}) => {
  const { push } = useHistory();
  const [currentMaterial, setCurrentMaterial] = useState(null);
  const [isTimeup, setIsTimeup] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const [finished, setFinished] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [totalCorrectAnswers, setTotalCorrectAnswers] = useState(0);
  const [totalWrongAnswers, setTotalWrongAnswers] = useState(0);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [passedMaterialsCount, setPassedMaterialsCount] = useState(0);
  const [isTimeOut, setIsTimeOut] = useState(false);
  const [onCloseModal, setOnCloseModal] = useState(false);
  const [currentLevelKey, setCurrentLevelKey] = useState('level_1_materials');
  const [numOfMaterials, setNumOfMaterials] = useState(recycleRightData[currentLevelKey].length);
  const [questionTime, setQuestionTime] = useState(850 * numOfMaterials);
  const [numOfTimeOuts, setNumOfTimeOuts] = useState(0);
  const timerRef = useRef();
  const [teachSwiping, setTeachSwiping] = useState(false);

  const CountDownRectangle = styled.div`
    position: fixed;
    top: ${Number(window.innerHeight / window.innerWidth) * -1.875 + 6.375}%;
    right: 4.5%;
    height: ${(Number(window.innerHeight / window.innerWidth) > 1.5) ? 3.3 : 4.5}vh;
    width: 20vw;
    background-color: #48802A;
    border-radius: 4vw;
  `;

  useEffect(() => {
    setIsTimeup(false);
  }, [currentMaterial]);

  /**
   * Update current material after each answer
   */
  useEffect(() => {
    const setMat = () => {
      const firstUndoneMaterial = recycleRightData[currentLevelKey]
        .sort((a, b) => a.oidx > b.oidx)
        .find(({ mat_id }) => doneMaterials
          .map((obj) => obj.split('-')[1]).indexOf(mat_id.toString()) === -1);

      if (firstUndoneMaterial) return setCurrentMaterial(firstUndoneMaterial);
      return finish();
    };

    if (!finished) setMat();
  }, [currentLevel, doneMaterials]);

  /**
   * Set feedback time duration and each question time lenght after each answer
   */
  useEffect(() => {
    if (recycleRightData[currentLevelKey].length === questionIndex) {
      setTimeout(() => finished, FEEDBACK_MESSAGE_DURATION);
      finish();
    }
    if (questionIndex > 0) {
      setQuestionTime(8000);
    }
  }, [questionIndex]);

  /**
   * After finish or reset of each level,
   * question index and number of correct and wrong answers will be updated
   */
  const finish = () => {
    setQuestionIndex(0);
    setTotalCorrectAnswers(doneMaterials.filter((mat) => mat.split('-')[0] === 'correct').length);
    setTotalWrongAnswers(doneMaterials.filter((mat) => mat.split('-')[0] === 'wrong').length);
    timer = setTimeout(() => {
      setModalVisible(true);
      clearTimeout(timer);
    }, FEEDBACK_MESSAGE_DURATION);
    setFinished(true);
  };

  /**
   * Number of total questions which were answered untill now
   */
  useEffect(() => {
    let total = 0;
    for (let i = 1; i < currentLevel + 1; i += 1) {
      total += recycleRightData[`level_${i}_materials`].length;
    }
    setPassedMaterialsCount(total);
  });

  /**
   * If the user selects recycable option as an answer
   */
  const swipedRecycleable = () => {
    const { is_recyclable } = currentMaterial;

    // track event
    trackEvent(events.DZ_RR_ANSWER, {
      mat_id: recycleRightData[currentLevelKey][questionIndex].mat_id,
      correct: is_recyclable,
      level: currentLevel + 1,
      time_spent: questionIndex === 0
        ? turnMsToSeconds((answeredElapsedTime - (numOfMaterials / 10)) * 1000).complete
        : turnMsToSeconds(answeredElapsedTime * 1000).complete,
      index: questionIndex
    });
    if (is_recyclable) {
      return correct();
    }
    return wrong();
  };

  /**
   * If the user selects not recycable option as an answer
   */
  const swipedNOTRecycleable = () => {
    const { is_recyclable } = currentMaterial;

    // track event
    trackEvent(events.DZ_RR_ANSWER, {
      mat_id: recycleRightData[currentLevelKey][questionIndex].mat_id,
      correct: !is_recyclable,
      level: currentLevel + 1,
      time_spent: questionIndex === 0
        ? turnMsToSeconds((answeredElapsedTime - (numOfMaterials / 10)) * 1000).complete
        : turnMsToSeconds(answeredElapsedTime * 1000).complete,
      index: questionIndex
    });
    if (!is_recyclable) {
      return correct();
    }
    return wrong();
  };

  /**
   * If the answer is correct
   */
  const correct = () => {
    handleTeachSwiping();
    setFeedback('correct');
    setDoneMaterial(`correct-${currentMaterial.mat_id.toString()}`);
  };

  /**
   * If the answer is wrong
   */
  const wrong = () => {
    handleTeachSwiping();
    setFeedback('wrong');
    setDoneMaterial(`wrong-${currentMaterial.mat_id.toString()}`);
  };

  const handleTeachSwiping = () => {
    if (localStorage.getItem('isSwiped') !== 'true' && questionIndex > 1) {
      setTeachSwiping(true);
    }
  };

  const onCloseTeachSwiping = () => {
    localStorage.setItem('isSwiped', 'true');
    setTeachSwiping(false);
  };

  useEffect(() => {
    if (!finished && feedback) {
      setQuestionIndex(questionIndex + 1);
      timer = setTimeout(() => {
        setFeedback(null);
        clearTimeout(timer);
      }, FEEDBACK_MESSAGE_DURATION);
    }
  }, [feedback, finished]);

  useEffect(() => {
    if (isTimeOut) {
      setNumOfTimeOuts(numOfTimeOuts + 1);
    }
  }, [isTimeOut, currentLevel]);

  useEffect(() => {
    localStorage.setItem('isSwiped', 'false');
  }, []);

  if (!currentMaterial) return null;

  const onStart = () => {
    if (finished) timerRef.current.stop();
  };

  const onComplete = () => {
    setIsTimeup(false);
    setIsTimeOut(true);
    setDoneMaterial(`wrong-${currentMaterial.mat_id.toString()}`);

    // track event
    trackEvent(events.DZ_RR_TIMEOUT, {
      level: currentLevel + 1,
      mat_id: recycleRightData[currentLevelKey][questionIndex].mat_id,
      index: questionIndex
    });
  };

  /**
   * When close button is pressed, all the varibales should be reset
   */
  const onClose = () => {
    setSwiperCurrentLevel(0);
    setCurrentLevelKey('level_1_materials');
    removeDoneMaterial(doneMaterials.length);
    setModalVisible(false);
    setIsTimeup(false);
    setFinished(false);
    setQuestionIndex(0);
    setQuestionTime(100 * numOfMaterials + 8000);
    setNumOfTimeOuts(0);
    iframeCall('clearDeepLink');

    // track event
    trackEvent(events.DZ_RR_CLOSE_TAP, {
      level: currentLevel + 1,
      mat_id: recycleRightData[currentLevelKey][questionIndex].mat_id,
      index: questionIndex
    });
    push('/landing');
  };

  /**
   * When the time out modal is closed
   */
  const onCloseTimeOutModal = () => {
    setIsTimeOut(false);
    if (
      recycleRightData[currentLevelKey].length
      === doneMaterials.slice(
        passedMaterialsCount, doneMaterials.length
      ).length
    ) {
      setQuestionIndex(recycleRightData[currentLevelKey].length - 1);
    } else {
      setQuestionIndex(questionIndex + 1);
    }
    timer = setTimeout(() => {
      setFeedback(null);
      clearTimeout(timer);
    });

    // track event
    trackEvent(events.DZ_RR_TIMEOUT_CONTINUE);
  };

  /**
   * When the restart button is pressed
   */
  const onRestart = () => {
    setIsTimeOut(false);
    timer = setTimeout(() => {
      setFeedback(null);
      clearTimeout(timer);
    });
    setModalVisible(false);
    setFinished(false);
    setQuestionIndex(0);
    setQuestionTime(100 * numOfMaterials + 8000);
    removeDoneMaterial(questionIndex + 1);
    setNumOfTimeOuts(0);

    // track event
    trackEvent(events.DZ_RR_TIMEOUT_RESTART_LEVEL_BTN_TAP);
  };

  /**
   * When the continue button is pressed
   */
  const onContinue = () => {
    setQuestionIndex(0);
    setQuestionTime(100 * numOfMaterials + 8000);
    setSwiperCurrentLevel(currentLevel + 1);
    setCurrentLevelKey(`level_${Number(currentLevelKey.split('_')[1].split('_')[0]) + 1}_materials`);
    setNumOfMaterials(recycleRightData[currentLevelKey].length);
    setModalVisible(false);
    setIsTimeup(false);
    setFinished(false);
    setNumOfTimeOuts(0);

    // track event
    trackEvent(events.DZ_RR_LEVEL_SUMMARY_NEXT_BTN_TAP);
  };

  /**
   * When the play again button is pressed
   */
  const onPlayAgain = () => {
    removeDoneMaterial(recycleRightData[currentLevelKey].length);
    setModalVisible(false);
    setIsTimeup(false);
    setFinished(false);
    setQuestionIndex(0);
    setQuestionTime(100 * numOfMaterials + 8000);
    setNumOfTimeOuts(0);

    // track event
    trackEvent(events.DZ_RR_LEVEL_SUMMARY_RESTART_BTN_TAP);
  };

  /**
   * When the play all game again button is pressed
   */
  const playAllAgain = () => {
    setOnCloseModal(true);
    setSwiperCurrentLevel(0);
    setCurrentLevelKey('level_1_materials');
    removeDoneMaterial(doneMaterials.length);
    setModalVisible(false);
    setIsTimeup(false);
    setFinished(false);
    setQuestionIndex(0);
    setQuestionTime(100 * numOfMaterials + 8000);
    setNumOfTimeOuts(0);

    // track event
    trackEvent(events.DZ_RR_FINISHED_PLAY_AGAIN_BTN_TAP);
  };

  return (
    <Container>
      {
        teachSwiping ? (
          <>
            <TeachSwipingModal
              onClose={onCloseTeachSwiping}
              onRestart={onRestart}
            />
            <StaticGameScreen
              questionIndex={questionIndex}
              currentLevel={currentLevel}
              modalVisible={false}
              doneMaterials={doneMaterials}
              passedMaterialsCount={passedMaterialsCount}
              isOnBoarding={false}
            />
          </>
        ) : isTimeOut ? (

          <>
            <TimeOutModal
              onClose={onCloseTimeOutModal}
              onRestart={onRestart}
            />
            <StaticGameScreen
              questionIndex={questionIndex}
              currentLevel={currentLevel}
              modalVisible={false}
              doneMaterials={doneMaterials}
              passedMaterialsCount={passedMaterialsCount}
              isOnBoarding={false}
            />
          </>
        ) : (
          <>
            {!feedback && !modalVisible
              && !rrGameOnly && (<CloseButton role="button" tabIndex={0} src={images.close} alt="Close" onClick={onClose} />)}
            {!finished && !feedback && !modalVisible && (
              <TopContainer>
                <CountDownRectangle />
                <CountDownContainer>
                  <Countdown
                    date={Date.now() + questionTime}
                    renderer={renderer}
                    ref={timerRef}
                    onStart={onStart}
                    onComplete={onComplete}
                  />

                  <TimerImage
                    src={clockIcon}
                    alt="Timer"
                  />
                </CountDownContainer>
              </TopContainer>
            )}
            {!feedback
              && !modalVisible
              && (
                <Levels
                  levels={recycleRightData}
                  currentLevelKey={currentLevelKey}
                  modalVisible={modalVisible}
                />
              )}
            {
              modalVisible
                ? (
                  <div style={{ display: 'relative' }}>
                    <RoundResult
                      isVisible={modalVisible}
                      clearedLevel={currentLevel + 1} // To handle zero-based index
                      totalCorrectAnswers={totalCorrectAnswers}
                      totalWrongAnswers={totalWrongAnswers}
                      onClose={onClose}
                      onContinue={onContinue}
                      onPlayAgain={onPlayAgain}
                      doneMaterials={doneMaterials}
                      currentLevelKey={currentLevelKey}
                      playAgain={playAllAgain}
                      onCloseModal={onCloseModal}
                      iamDone={onClose}
                      numOfTimeOuts={numOfTimeOuts}
                    />
                  </div>
                ) : (
                  <>
                    {
                      (feedback && feedback !== 'timesup')
                        ? (
                          <Feedbacks
                            feedbackStatus={feedback}
                            currentLevel={currentLevel}
                            modalVisible={false}
                            doneMaterials={doneMaterials}
                            passedMaterialsCount={passedMaterialsCount}
                          />
                        ) : (
                          <>
                            <div style={{ marginTop: '1%' }}>
                              <Deck
                                disabled={isTimeup}
                                currentLevelKey={currentLevelKey}
                                onSwipeLeft={swipedNOTRecycleable}
                                onSwipeRight={swipedRecycleable}
                                questionIndex={questionIndex}
                                feedback={feedback}
                              />
                            </div>
                            <ButtonsContainer>
                              <ButtonImage role="button" tabIndex={0} alt="Not recyclable" src={images.decline} onClick={swipedNOTRecycleable} />
                              <ButtonImage role="button" tabIndex={0} alt="Recyclable" src={images.recycable} onClick={swipedRecycleable} />
                            </ButtonsContainer>
                            <GameStatusIndicator
                              totalMaterials={recycleRightData[currentLevelKey]}
                              doneMaterials={doneMaterials}
                              prevTotalMaterials={passedMaterialsCount}
                            />
                          </>
                        )
                    }
                  </>
                )
            }
          </>
        )
      }
    </Container>
  );
};

export default connect(
  (store) => ({
    currentLevel: store.recycleRight.currentLevel,
    doneMaterials: store.recycleRight.doneMaterials,
    removeDoneMaterial: store.recycleRight.removeDoneMaterial,
    recycleRightData: store.recycleRight.allRrData,
    rrGameOnly: store.app.rrGameOnly
  }),
  (dispatch) => ({
    setDoneMaterial: (material) => dispatch(actions.setDoneMaterial(material)),
    removeDoneMaterial: (numOfQuestions) => dispatch(actions.removeDoneMaterial(numOfQuestions)),
    setSwiperCurrentLevel: (level) => dispatch(actions.setSwiperCurrentLevel(level)),
  })
)(Game);
